<template>
  <div class="LTab">
    <div class="lt-items">
      <div
        class="lt-item paused"
        v-for="(item, index) in tabs"
        :key="index"
        :class="activeclass(index)"
        :ref="'vtsitem'+index"
        @mouseover="(evt)=>{hoverHandle(index,evt)}"
        @mouseout="mouseoutF"
      >
        <div class="lt-title">{{item}}</div>
      </div>
    </div>
    <template v-for="(item, index) in tabs">
      <transition name="fadeIn" :key="index">
        <div
          class="lt-content"
          v-if="activeIndex === index"
          @mouseover="mouseoverF"
          @mouseout="mouseoutF"
        >
          <slot :name="index"></slot>
        </div>
      </transition>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LTab',
  data() {
    return {
      tabs: [],
      activeIndex: -1,
      isHovering: false,
      timeoutSecond: 5000,
    };
  },
  props: {
    active: Boolean,
  },
  watch: {
    active(n) {
      if (n) {
        this.activeIndex = 0;
      }
    },
  },
  methods: {
    activeclass(index) {
      return {
        paused: this.isHovering,
        running: !this.isHovering,
        active: this.activeIndex === index,
      };
    },
    mouseoverF() {
      this.isHovering = true;
    },
    mouseoutF() {
      this.isHovering = false;
    },
    hoverHandle(index) {
      this.isHovering = true;
      this.activeIndex = index;
    },
  },
  created() {
    const tmparr = [];
    Object.keys(this.$slots).forEach((element) => {
      if (this.$slots[element] && this.$slots[element][0].data.attrs.title) {
        tmparr.push(this.$slots[element][0].data.attrs.title);
      }
    });
    this.tabs = tmparr;
  },
  mounted() {
    if (this.$isIe9) {
      this.activeIndex = 0;
    }
    setInterval(() => {
      // 移出实现没必要切换tab
      if (!this.active) {
        return;
      }
      this.timeoutSecond -= 32;
      if (this.timeoutSecond > 0) {
        return;
      }
      this.timeoutSecond = 5000;
      if (!this.isHovering) {
        this.activeIndex += 1;
        if (this.activeIndex >= this.tabs.length) {
          this.activeIndex = 0;
        }
        this.top = `${(100 / this.tabs.length) * this.activeIndex}%`;
      }
    }, 32);
  },
};
</script>
<style lang="scss" scoped>
.LTab {
  position: relative;
  width: 100%;
  height: 690px;
  overflow: hidden;
  .lt-lines {
    position: absolute;
    left: 10px;
    top: 75px;
    z-index: 3;
    width: 4px;
    height: 390px;
    cursor: pointer;
    float: left;
    background: #f2f2f2;
    border-radius: 2px;
    span {
      width: 30px;
      text-align: center;
      left: -13px;
      font-weight: bold;
    }
    & > span:first-child {
      position: absolute;
      top: -22px;
    }
    & > span:last-child {
      position: absolute;
      bottom: -22px;
    }
    .ltl-block {
      position: relative;
      width: 100%;
      margin-left: -7px;
      padding: 0 10px;
    }
    .lt-line {
      position: absolute;
      left: 0;
      width: 100%;
      background: #000000;
      border-radius: 2px;
      transition: all linear 0.2s;
    }
  }
  .lt-items {
    position: relative;
    // margin: 0 30px 0 0;
    margin-bottom: 30px;
    height: 40px;
    width: 100%;
    overflow: hidden;
    .lt-item:hover,
    .lt-item.active {
      .lt-title {
        font-family: MicrosoftYaHeiUI;
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        &::before {
          content: "";
          position: absolute;
          left: 0px;
          bottom: 0;
          width: 100%;
          height: 1px;
          border-radius: 3px;
          background: #c1c1c1;
        }
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1px;
          border-radius: 3px;
          background: #000000;
          animation: fullwidth 5s 1 linear;
          -webkit-animation: fullwidth 5s 1 linear;
        }
      }
    }
    .lt-item {
      width: 100px;
      float: left;
      margin-bottom: 10px;
      height: 20px;
      line-height: 20px;
      position: relative;
      text-align: center;
      color: #999999;
      z-index: 3;
      cursor: pointer;
      margin-left: 59px;
      &:first-child {
        margin-left: 0;
        text-align: left;
      }
      .lt-title {
        position: relative;
        font-family: PingFangSC-Regular;
        font-family: MicrosoftYaHeiUILight;
        font-size: 20px;
        color: #666666;
        line-height: 20px;
        height: 40px;
        display: inline-block;
      }
    }
    .pbt-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 70px;
      background: #f7f7f7;
      z-index: 1;
      transition: all linear 0.1s;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        height: 100%;
        width: 5px;
        background-image: linear-gradient(212deg, #7f77fa 1%, #186fff 61%);
      }
    }
  }
  .lt-content {
    overflow: hidden;
    position: relative;
  }
  .lt-item.active.paused {
    .lt-title {
      &::after {
        animation-play-state: paused;
        -webkit-animation-play-state: paused;
      }
    }
  }
  .lt-item.active.running {
    .lt-title {
      &::after {
        animation-play-state: running;
        -webkit-animation-play-state: running; /* Safari 和 Chrome */
      }
    }
  }
}
</style>
